import {useState, useEffect} from 'react';
import {HelpSidePanelContent} from '../common/help/help-side-panel';
import {HELP_CONTENTS} from '../common/help/help-contents';

type HelpState = {
    content: HelpSidePanelContent;
    isOpen: boolean;
};

let listeners: ((state: HelpState) => void)[] = [];
let currentState: HelpState = {content: HELP_CONTENTS.EMPTY, isOpen: false};

const emitChange = () => {
    listeners.forEach((listener) => listener(currentState));
};

export const showHelp = (content: HelpSidePanelContent) => {
    currentState = {content, isOpen: true};
    emitChange();
};

export const hideHelp = () => {
    currentState = {content: HELP_CONTENTS.EMPTY, isOpen: false};
    emitChange();
};

export const useHelp = () => {
    const [helpContent, setHelpContent] = useState<HelpSidePanelContent>(currentState.content);
    const [helpOpen, setHelpOpen] = useState<boolean>(currentState.isOpen);

    useEffect(() => {
        const listener = (state: HelpState) => {
            setHelpContent(state.content);
            setHelpOpen(state.isOpen);
        };
        listeners.push(listener);
        return () => {
            listeners = listeners.filter((l) => l !== listener);
        };
    }, []);

    return {
        helpContent,
        setHelpContent,
        helpOpen,
        setHelpOpen,
        showHelp,
        hideHelp,
    };
};
